import base from './base'
export default {
  ...base,
  name: {
    type: ['undefined', 'string']
  },
  path: {
    type: ['undefined', 'string']
  },
  type: {
    type: ['undefined', 'string']
  },
  is_verified: {
    type: ['boolean'],
    default: () => false
  },
}
